import React from "react"
import * as styles from "./applyContent.module.scss"

const ApplyContent = React.memo((props) => {
  return (
    <div className={styles.container}>
      <h1>Contact</h1>
      <hr />
      <div className={styles.tip}>
        <p>申请须知：</p>
        <p>
          邮件中需附带游戏介绍文档、游戏截图、游戏视频、游戏可玩demo以及开发组联系方式
          游戏开发组需为无母公司，且非隶属于有大型商业游戏案例公司。完全自主独立运行的个人/团队
          优先考虑BOOOM或其他Game Jam上所诞生的游戏作品
        </p>
      </div>
      <div className={styles.emailTip}>
        如有申请发行的意向，请发送邮件至：
        <a href="mailto:publishing@gcores.com">publishing@gcores.com</a>
      </div>
    </div>
  )
})

ApplyContent.displayName = "ApplyContent"
export default ApplyContent
